export const NEFI_EI = {
  email: 'test@email.com',
};
